/* istanbul ignore file */
import {CustomCssVarsFnParams} from '@wix/wixstores-client-storefront-common/dist/types/types';

export const getOptionsButtonsCustomCssVars = ({styleParams}: CustomCssVarsFnParams) => {
  const {
    productPage_buttonOptionsVerticalPadding,
    productPage_buttonOptionsHorizontalPadding,
    productPage_buttonOptionsColumnsNumber,
  } = styleParams.numbers;

  const getButtonOptionsGridColumns = (): string => {
    return `repeat(${productPage_buttonOptionsColumnsNumber}, minmax(0, 1fr))`;
  };

  return {
    buttonOptionsPadding: `${productPage_buttonOptionsVerticalPadding}px ${productPage_buttonOptionsHorizontalPadding}px`,
    buttonOptionsGridColumns: getButtonOptionsGridColumns(),
  };
};
